import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import Invitations from './modules/invitations'
import Auth from './modules/auth'
import Properties from './modules/properties'
import Signing from './modules/signing'
import Companies from './modules/companies'
import LegacyContracts from './modules/legacy-contracts'
import Screening from './modules/screening'
import ContractWizard from './modules/contract-wizard'
import DraftContracts from './modules/draft-contracts'
import CreditCard from './modules/credit-card'
import ContractSignature from './modules/contract-signature'
import Subscription from './modules/subscription'

import SuccessBar from './modules/success-bar.js'

Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [
        createPersistedState({
            storage: window.sessionStorage
        }),
    ],
    modules: {
        Invitations,
        Auth,
        Properties,
        Companies,
        LegacyContracts,
        Screening,
        ContractWizard,
        DraftContracts,
        ContractSignature,
        Signing,
        CreditCard,
        Subscription,
        SuccessBar,
    }
});
